<template>
  <span v-if="showTooltip == 'true'">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn @click="languageSwitcher"  text v-on="on">
           {{$t("_lang")}}
        </v-btn>
      </template>
      <span>{{ $t("CHANGE_LANGUAGE") }}</span>
    </v-tooltip>
</span>
  <span v-else>
    <v-btn @click="languageSwitcher" :class="{'primary--text':primaryColor}"  text>
      {{$t("_lang")}}
    </v-btn>
</span>
</template>

<script>
import Vue from "vue";
export default {
  name: "ad-changeLanguage",
  props: ["showTooltip",'primaryColor'],
  created() {
    localStorage.lang ? localStorage.lang : (localStorage.lang = "ar");
    const direction = localStorage.lang == "ar" ? true : false;
    this.$vuetify.rtl = direction;
    this.locale = localStorage.lang;
    this.$vuetify.lang.current = localStorage.lang;
    this.direction = direction;
    this.$emit("swichLanguage", this.direction);
    Vue.i18n.set(localStorage.lang);
    this.$store.commit("setLanguage", localStorage.lang);
  },
  data() {
    return {
      direction: this.$store.state.direction
    };
  },
  methods: {
    languageSwitcher: function() {
      this.direction = !this.direction;
      this.$vuetify.rtl = this.direction;
      localStorage.lang = this.direction ? "ar" : "en";
      this.locale = localStorage.lang;
      this.$vuetify.lang.current = localStorage.lang;
      Vue.i18n.set(localStorage.lang);
      this.$store.commit("setLanguage", localStorage.lang);
      this.$emit("swichLanguage", this.direction);
    }
  }
};
</script>
